export const GET_APPOINTMENT_LIST = "GET_APPOINTMENT_LIST";

export const GET_RESOURCE_LIST = "GET_RESOURCE_LIST";

export const GET_APPOINTMENT_DETAIL = "GET_APPOINTMENT_DETAIL";

export const CREATE_APPOINTMENT = "CREATE_APPOINTMENT";

export const UPDATE_STATUS = "UPDATE_STATUS";

export const UPDATE_APPOINTMENT = "UPDATE_APPOINTMENT";

export const RELOAD_CALENDAR = "RELOAD_CALENDAR";

export const SELECT_RESOURCE = "SELECT_RESOURCE";

export const GET_FILTERED_LIST = "GET_FILTERED_LIST";

export const CREATE_BLOCK_TIME = "CREATE_BLOCK_TIME";

export const DELETE_BLOCK_TIME = "DELETE_BLOCK_TIME";

export const CHECKOUT = "CHECKOUT";

export const GET_APPOINTMENT_SPECIFIC_DATE = "GET_APPOINTMENT_SPECIFIC_DATE";

export const CHECK_UPDATE = "CHECK_UPDATE";

export const GET_LIST_SEARCH = "GET_LIST_SEARCH";

export const DRAG_DROP_UPDATE = "DRAG_DROP_UPDATE";

export const GET_DEPOSIT_LIST = "GET_DEPOSIT_LIST";

export const GET_DEPOSIT_DETAIL = "GET_DEPOSIT_DETAIL";

export const CHANGE_DELETE_STATUS = "CHANGE_DELETE_STATUS";

export const CHANGE_ALL_DELETE_STATUS = "CHANGE_ALL_DELETE_STATUS";

export const MAKE_DEPOSIT_REFUND = "MAKE_DEPOSIT_REFUND";

export const RELOAD_DEPOSIT_LIST = "RELOAD_DEPOSIT_LIST";

export const CHARGE_DEPOSIT = "CHARGE_DEPOSIT";

export const EXPORT_APPOINTMENT = "EXPORT_APPOINTMENT";

export const INITIALIZE_PAYMENT = "INITIALIZE_PAYMENT";
export const ADD_STRIPE_PAYMENT_METHOD = "ADD_STRIPE_PAYMENT_METHOD";
